import { formatMeterValue, MeterType } from "@next-platform/packages-ts-types";
import resolveHudMeterValue from "./resolveHudMeterValue";
const NOT_ROLLED = "—";
/**
 * The value text a meter button speaks/shows, identical to what `RulebookMeterInline` renders: dice as
 * `<face> / dN` through the same `chat:rulebook.hud.dice.sides` key the visible pill uses, clocks as the
 * snapshot's clock label, numbered meters via `formatMeterValue` with the unit, everything else as the plain
 * number. `undefined` when the snapshot carries no entry for the meter.
 */
export default function formatMeterButtonValue({ meter, snapshot, t, }) {
    const hudMeter = snapshot.meta.meters?.[meter.id];
    if (hudMeter === undefined || hudMeter === null) {
        return undefined;
    }
    const value = resolveHudMeterValue({ meter, hudMeter });
    if (meter.type === MeterType.DICE) {
        const sides = meter.sides ?? meter.max ?? "";
        return `${value < 1 ? NOT_ROLLED : value} ${t("chat:rulebook.hud.dice.sides", { sides, defaultValue: "/ d{{sides}}" })}`;
    }
    if (meter.type === MeterType.CLOCK) {
        return snapshot.meta.clock?.label ?? "";
    }
    if (meter.type === MeterType.NUMBER) {
        return `${formatMeterValue(meter, value)} ${meter.unit ?? ""}`.trim();
    }
    return String(value);
}
